import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from '../config'

Vue.use(Vuex)

const initialState = {
  interests: []
}

const getters = {
  interests: state => state.interests
}

const mutations = {
  interests: (state, interests) => {
    state.interests = interests
  }
}

const actions = {
  async fetchInterests ({ commit }) {
    const response = await axios.get(`${config.getRootApi()}/interests`)
    commit('interests', response.data)
  },
  async createInterest ({ commit, state }, name) {
    const response = await axios.post(`${config.getRootApi()}/interests`, { name: name })
    if (response.status === 201) {
      const newInterest = response.data
      commit('interests', [...state.interests, newInterest])
      return newInterest
    } else {
      console.error('Could not create interest')
    }
  }
}

export default {
  state: initialState,
  getters,
  mutations,
  actions
}
